<div [class.disabled]="form.disabled" class="h-100 d-flex flex-column overflow-hidden">
    <div class="position-relative overflow-hidden flex-grow-1">
        <p-editor
            placeholder="请在此输入退单理由..."
            [formControl]="form.controls.reason"
            [disabled]="form.controls.reason.disabled"
            (onInit)="onEditorInit($event)"
            (click)="onEditorClick($event)"
        />
        <input
            #attachmentInput
            type="file"
            accept=".pdf,.docx,.zip,.mp4,.mov"
            class="d-none"
            [disabled]="form.disabled || isUploadingAttachment"
            (change)="onAttachmentSelected($event)"
        />
        <div
            *ngIf="isUploadingAttachment"
            class="attachment-upload-status text-secondary"
            role="status"
            aria-live="polite"
        >
            <div class="d-flex align-items-center">
                <span class="spinner-border spinner-border-sm flex-shrink-0 me-2" aria-hidden="true"></span>
                <span class="text-truncate flex-grow-1 me-2">{{ uploadingAttachmentName }}</span>
                <strong *ngIf="attachmentUploadProgress < 100; else processing" class="flex-shrink-0">
                    {{ attachmentUploadProgress }}%
                </strong>
                <ng-template #processing><span class="flex-shrink-0">处理中...</span></ng-template>
            </div>
            <div
                class="progress attachment-upload-progress mt-2"
                role="progressbar"
                aria-label="附件上传进度"
                aria-valuemin="0"
                aria-valuemax="100"
                [attr.aria-valuenow]="attachmentUploadProgress"
            >
                <div
                    class="progress-bar progress-bar-striped progress-bar-animated"
                    [style.width.%]="attachmentUploadProgress"
                ></div>
            </div>
        </div>
    </div>
    <div class="mt-3">
        <div class="d-flex align-items-center">
            <div><span>质检员:&nbsp;</span></div>
            <div>
                <app-treatment-reviewer
                    (onReviewerSelected)="form.controls.reviewerId.setValue($event.id)"
                    [reviewerId]="form.controls.reviewerId.value"
                    [isDisable]="form.controls.reviewerId.disabled"
                />
            </div>
        </div>
    </div>
</div>
